<div class="rs-msgbox rs-msgbox-warning">
  <div class="rs-msgbox-title" id="ac-warningOverlayer-label">
    {{ 'option.details.fiberMigration.warning.' + action + '.title' | translate }}
  </div>
  <div class="rs-msgbox-content" id="ac-warningOverlayer-content">
    <p [innerHTML]="'option.details.fiberMigration.warning.' + action + '.content' | translate"></p>
  </div>
  <div class="rs-msgbox-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-order-m2">
        <a href="javascript:void(0)" class="rs-btn rs-btn-nl-so" (click)="confirmOrder()">{{
          'option.details.fiberMigration.warning.button.continue' | translate
        }}</a>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal">
          {{ 'option.details.fiberMigration.warning.button.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="rs-msgbox-icon">
    <i class="icon-Warning-box" aria-hidden="true"></i>
  </div>
</div>
